export class ViewModelEnviaCobrancaNovo {
    dataVencimento: string;
    dataNovo: string;
}